import HostIcon from '@mui/icons-material/DnsOutlined';
import PortIcon from '@mui/icons-material/SendToMobileOutlined';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import DescriptiveButton from 'components/DescriptiveButton/DescriptiveButton';
import Modal from 'components/Modal/Modal';
import React from 'react';

const cardStyle = {
  p: 2,
  cursor: 'pointer',
  '&:hover': {
    borderColor: 'primary.main',
    bgcolor: 'primary.lighter',
  },
};

const MoveNumber = ({ onClose, onHost, onPort }) => {
  return (
    <Modal
      open
      onClose={onClose}
      maxWidth="xs"
      fullWidth
      title="Use Phone Numbers You Already Own"
    >
      <Typography paragraph color="text.secondary">
        Already have a phone number you love? Choose how you want to use it.
        Host your number to maintain your current voice plan or port your number
        to upgrade your phone experience with Calling by Text In Church.
      </Typography>
      <Stack spacing={2}>
        <DescriptiveButton
          title="Host Number"
          description="Hosting a number allows you to keep your existing phone plan and voice provider, but enables you to use Text In Church for sending text messages."
          icon={<HostIcon />}
          onClick={onHost}
        />
        <DescriptiveButton
          title="Port Number"
          description="Porting your number allows you to seamlessly transfer your existing phone number to our platform. You'll maintain uninterrupted service while gaining access to advanced texting and calling features."
          icon={<PortIcon />}
          onClick={onPort}
        />
      </Stack>
    </Modal>
  );
};

export default MoveNumber;
